import React from 'react'
import './Projects.css'

interface Project {
  id: string
  title: string
  description: string
  status: 'coming-soon' | 'in-development' | 'released'
  image?: string
  genre: string
}

const projects: Project[] = [
  {
    id: '1',
    title: 'Unannounced Project',
    description: 'Details will be revealed when ready.',
    status: 'coming-soon',
    genre: 'TBA'
  },
  {
    id: '2',
    title: 'Unannounced Project',
    description: 'Details will be revealed when ready.',
    status: 'coming-soon',
    genre: 'TBA'
  },
  {
    id: '3',
    title: 'Unannounced Project',
    description: 'Details will be revealed when ready.',
    status: 'coming-soon',
    genre: 'TBA'
  }
]

const Projects: React.FC = () => {
  return (
    <section id="projects" className="section projects">
      <div className="container">
        <h2 className="section-title">Our Projects</h2>
        <p className="section-subtitle">
          We're working on exciting projects behind the scenes. Official announcements coming soon!
        </p>
        
        <div className="projects-grid">
          {projects.map((project) => (
            <div key={project.id} className="project-card fuzzed">
              <div className="project-image-placeholder">
                <div className="project-status-badge classified">
                  🤐 UNANNOUNCED
                </div>
                <div className="classified-overlay">
                  <div className="classified-text">NO DETAILS</div>
                  <div className="classified-subtext">UNANNOUNCED</div>
                </div>
              </div>
              <div className="project-content">
                <div className="project-genre">{project.genre}</div>
                <h3 className="project-title">{project.title}</h3>
                <p className="project-description">{project.description}</p>
                <button className="project-button classified-button" disabled>
                  📋 NOT YET ANNOUNCED
                </button>
              </div>
            </div>
          ))}
        </div>
        
        <div className="more-projects">
          <div className="coming-soon">
            🎮 Multiple projects in early development - announcements when we're ready to share!
          </div>
        </div>
      </div>
    </section>
  )
}

export default Projects